// extracted by mini-css-extract-plugin
module.exports = {"titleCol":"ContactForm_titleCol__yumUg","formCol":"ContactForm_formCol__uwRR1","padText":"ContactForm_padText__P8sqs"};